import React from "react";

export default class ImageInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      base64: this.props.value,
    };

    this.fileInputRef = React.createRef();
  }

  // Converte un file in base64
  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Verifica estensione
    const validExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    const extension = file.name
      .split(".")
      .pop()
      .toLowerCase();
    if (!validExtensions.includes(extension)) {
      alert("Formato non valido. Usa: " + validExtensions.join(", "));
      return;
    }

    // Verifica dimensione file (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert("File troppo grande. Massimo 10MB.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target.result;
      console.log(
        "ImageInput: immagine caricata, lunghezza base64:",
        base64 ? base64.length : 0,
      );
      this.setState({ base64: base64 });
      if (this.props.onChange) this.props.onChange(base64);
    };
    reader.onerror = (error) => {
      console.error("ImageInput errore lettura file:", error);
      alert("Errore nel caricamento dell'immagine");
    };
    reader.readAsDataURL(file);
  };

  render() {
    const readOnly = this.props.readOnly;

    // Funzione helper per gestire correttamente l'URL dell'immagine
    const getImageUrl = (base64) => {
      if (!base64 || base64 === "") return "";
      // Se il base64 inizia già con "data:", non aggiungere il prefisso
      if (base64.startsWith("data:")) return `url("${base64}")`;
      // Altrimenti aggiungi il prefisso data:
      return `url("data:${base64}")`;
    };

    if (readOnly === true) {
      return (
        <div style={mainClass}>
          <div style={name}>{this.props.name}</div>
          <div
            style={{
              backgroundImage: getImageUrl(this.state.base64),
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "150px",
              height: "150px",
              border: "1px solid #888888",
              marginBottom: "10px",
              display:
                this.state.base64 === undefined || this.state.base64 === ""
                  ? "none"
                  : "block",
            }}
          ></div>
        </div>
      );
    }

    return (
      <div style={mainClass}>
        <div style={name}>{this.props.name}</div>
        <div
          style={{
            backgroundImage: getImageUrl(this.state.base64),
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: "150px",
            height: "150px",
            border: "1px solid #888888",
            marginBottom: "10px",
            display:
              this.state.base64 === undefined || this.state.base64 === ""
                ? "none"
                : "block",
          }}
        ></div>

        <input
          type="file"
          ref={this.fileInputRef}
          accept="image/jpeg,image/png,image/gif,image/webp"
          onChange={this.handleFileChange}
          style={{ display: "none" }}
        />

        <button
          type="button"
          onClick={() => this.fileInputRef.current.click()}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            backgroundColor: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: "4px",
          }}
        >
          Carica immagine
        </button>

        <div
          style={{
            fontSize: "11px",
            color: "#888",
            marginTop: "5px",
          }}
        >
          Max 10MB · JPG, PNG, GIF, WEBP
        </div>

        {this.state.base64 && this.state.base64 !== "" && (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              padding: 15,
              fontSize: "20px",
              cursor: "pointer",
              color: "#ff0000",
            }}
            onClick={() => {
              this.setState({ base64: "" });
              if (this.props.onChange) this.props.onChange("");
              // Reset input file
              if (this.fileInputRef.current) {
                this.fileInputRef.current.value = "";
              }
            }}
          >
            ✕
          </div>
        )}
      </div>
    );
  }
}

const mainClass = {
  padding: "10px",
  width: "200px",
  position: "relative",
};

const name = {
  marginBottom: "10px",
  fontWeight: "bold",
};

const inputText = {
  width: "300px",
};
